import React, { forwardRef, useState } from 'react'
import * as UIcons from '@iconscout/react-unicons'
import ClickAwayComponent from 'components/ClickAwayComponent'

export default function TagMultiSelect({ label, placeholder, options, values = [], onChange }) {
  const [search, setSearch] = useState('')

  const toggle = (option) => {
    onChange(values.includes(option) ? values.filter((value) => value !== option) : [...values, option])
  }

  const filteredOptions = options.filter((option) => option.toLowerCase().includes(search.trim().toLowerCase()))

  return (
    <div className="flex flex-col gap-2">
      {label && <label className="text-sm font-medium text-dark-blue">{label}</label>}

      <ClickAwayComponent
        Component={forwardRef(({ handleClick, open }, ref) => (
          <div className="relative" ref={ref}>
            <button
              type="button"
              onClick={handleClick}
              className="w-full flex items-center justify-between gap-2 border border-border-lines rounded-lg px-3 py-2.5 text-sm text-left text-secondary"
            >
              {placeholder}
              <UIcons.UilAngleDown size={16} className={`text-secondary shrink-0 ${open ? 'rotate-180' : ''}`} />
            </button>

            {
              open && (
                <div className="absolute left-0 right-0 top-[calc(100%+4px)] z-20 bg-white border border-border-lines rounded-xl shadow-lg overflow-hidden">
                  <div className="p-2 border-b border-border-lines">
                    <div className="relative">
                      <input
                        type="text"
                        autoFocus
                        value={search}
                        onChange={(event) => setSearch(event.target.value)}
                        placeholder="Search..."
                        className="w-full bg-background rounded-lg pl-8 pr-2 py-1.5 text-sm outline-none"
                      />
                      <UIcons.UilSearch className="text-placeholder absolute top-1/2 -translate-y-1/2 left-2.5" size={14} />
                    </div>
                  </div>

                  <ul className="max-h-60 overflow-y-auto py-1">
                    {
                      filteredOptions.map((option) => (
                        <li key={option}>
                          <button
                            type="button"
                            onClick={() => toggle(option)}
                            className="w-full flex items-center gap-2 text-left px-3 py-2 text-sm text-dark-blue hover:bg-background"
                          >
                            <span className={`w-4 h-4 rounded border flex items-center justify-center shrink-0 ${values.includes(option) ? 'bg-primary border-primary' : 'border-border-lines'}`}>
                              {values.includes(option) && <UIcons.UilCheck size={12} className="text-white" />}
                            </span>
                            {option}
                          </button>
                        </li>
                      ))
                    }
                    {!filteredOptions.length && <li className="px-3 py-2 text-sm text-secondary">No matches</li>}
                  </ul>
                </div>
              )
            }
          </div>
        ))}
      />

      {
        values.length > 0 && (
          <div className="flex flex-wrap gap-2">
            {
              values.map((value) => (
                <span key={value} className="inline-flex items-center gap-1.5 bg-background rounded-full pl-3 pr-2 py-1 text-xs font-medium text-dark-blue">
                  {value}
                  <button type="button" onClick={() => toggle(value)} className="flex items-center justify-center">
                    <UIcons.UilTimes size={12} className="text-secondary" />
                  </button>
                </span>
              ))
            }
          </div>
        )
      }
    </div>
  )
}
